// Identidad persistente de este equipo (navegador/PC) para vincularlo a una terminal.
// Se guarda en localStorage y en una cookie de larga duración como respaldo.
const KEY = "device_uid";

function readCookie() {
  const m = document.cookie.match(new RegExp(`(?:^|; )${KEY}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : "";
}
function writeCookie(id) {
  try { document.cookie = `${KEY}=${encodeURIComponent(id)}; path=/; max-age=${60 * 60 * 24 * 365 * 5}; SameSite=Lax`; } catch { /* noop */ }
}

export function getDeviceId() {
  let id = localStorage.getItem(KEY) || readCookie();
  if (!id) {
    id = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
  localStorage.setItem(KEY, id);
  writeCookie(id);
  return id;
}
